import { basicEnum } from "./base";

export const AssociateUserTypeEnum = basicEnum([
    {
        label: "ADMIN",
        value: "admin",
    },
    {
        label: "EMPLOYEE",
        value: "employee",
    },
    {
        label: "MARKETING",
        value: "marketing",
    },
]);

export namespace AssociateUserTypeEnum {
    export type Labels = (typeof AssociateUserTypeEnum)["labels"][number];
    export type Values = (typeof AssociateUserTypeEnum)["values"][number];
}
